import React, { useState } from 'react'
import FileUpload from '../../../components/FileUpload/FileUpload'
import RosterResults from './RosterResults'
import { domains } from '../../../lib/config'
import PropTypes from 'prop-types'
import Loading from 'components/Loading/Loading'
import {
  LICENSE_ASSIGNMENT,
  INSTRUCTIONS,
  BROWSE,
  ACCESS_TOKEN_TEXT,
  UPLOAD,
  TOOL_DESCRIPTION,
  NS_DESCRIPTION,
  NS_CUSTOMER,
  SKU,
  ADMIN_EMAILS,
  DISTRICT_NAME,
  EXTERNAL_SITE,
} from './constants'

import {
  AccessToken,
  AccessTokenText,
  RosterButton,
  Instructions,
  ExampleImage,
  UploadSection,
} from './styles'

RosterLayout.propTypes = {
  error: PropTypes.string,
  file: PropTypes.object,
  fileName: PropTypes.string.isRequired,
  handleUpload: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFileChange: PropTypes.func.isRequired,
  uploadResults: PropTypes.object,
}

export default function RosterLayout(props) {
  const { isLoading } = props || {}
  const [createAccessTokens, setCreateAccessTokens] = useState(false)

  return (
    <React.Fragment>
      <Loading isLoading={isLoading} message="Processing file...." />
      <h2>{LICENSE_ASSIGNMENT}</h2>
      <hr />
      <Instructions>{INSTRUCTIONS}</Instructions>
      <FileUpload
        disabled={props.isLoading}
        fileName={props.fileName}
        key={props.fileName}
        onFileChange={props.onFileChange}
      >
        {BROWSE}
      </FileUpload>
      <UploadSection>
        <div>
          {!!props.uploadResults && (
            <RosterResults
              error={props.error}
              uploadResults={props.uploadResults}
            />
          )}
        </div>
        <div>
          <AccessToken
            onClick={() => setCreateAccessTokens(!createAccessTokens)}
          >
            <input checked={createAccessTokens} type="checkbox" />
            <AccessTokenText>{ACCESS_TOKEN_TEXT}</AccessTokenText>
          </AccessToken>
          <RosterButton
            color={'#002855'}
            disabled={!props.file || props.isLoading}
            onClick={() => props.handleUpload({ ...props, createAccessTokens })}
          >
            {UPLOAD}
          </RosterButton>
        </div>
      </UploadSection>
      <h3>Tool Description</h3>
      <p>{TOOL_DESCRIPTION}</p>
      <h4>Fields Description</h4>
      <ul>
        <li>
          <b>NsSubscriptionId:</b> {NS_DESCRIPTION}
        </li>
        <li>
          <b>NsCustomerId:</b> {NS_CUSTOMER}
        </li>
        <li>
          <b>Sku:</b> {SKU}
        </li>
        <li>
          <b>AdminEmails:</b> {ADMIN_EMAILS}
        </li>
        <li>
          <b>DistrictName:</b> {DISTRICT_NAME}
        </li>
        <li>
          <b>ExternalSiteId:</b> {EXTERNAL_SITE}
        </li>
      </ul>
      <Instructions>
        All uploaded spreadsheets should be formatted like this:
      </Instructions>
      <ExampleImage
        src={`${domains.CDN_DOMAIN}/assets/img/roster_licenses.png`}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/roster/RosterLayout.js